import script from "./ForgotThePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotThePassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgotThePassword.vue?vue&type=style&index=0&id=14fd1089&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fd1089"]])

export default __exports__